import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IBundlesListState {
    status: string
    data: null
    errors: any
}

const initialState: IBundlesListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}
const bundlesList = createSlice({
    name: 'localization/bundles-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const bundlesListActions = bundlesList.actions
export default bundlesList.reducer
